export default __webpack_public_path__ + "static/Ziegler_Card-7d2997be5056cedea2d4ecb27aa78541.png";